import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import logo from '../assets/supple_bakes_cropped_logo.png';
import './Header.css';

const Header = ({ title = 'Cake Shop' }) => {
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <header className="header glass-effect">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">
            <img src={logo} alt="Supple Bakes" className="header-logo" />
            {title}
          </h1>
        </div>
        <div className="header-right">
          <Link to="/cart" className="cart-button ripple">
            <svg className="cart-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
            </svg>
            {itemCount > 0 && <span className="cart-badge scale-in">{itemCount}</span>}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
